import React, { useState } from 'react';
import AIChatbot from './AIChatbot';
import './ChatbotButton.css';

const ChatbotButton = ({ 
  position = 'bottom-right',
  apiBaseUrl = 'http://localhost:8001/api',
  theme = 'light'
}) => {
  const [isChatOpen, setIsChatOpen] = useState(false);

  const positionClass = {
    'bottom-right': 'chatbot-btn-bottom-right',
    'bottom-left': 'chatbot-btn-bottom-left',
    'top-right': 'chatbot-btn-top-right',
    'top-left': 'chatbot-btn-top-left'
  };

  return (
    <>
      <button
        className={`chatbot-floating-btn ${positionClass[position]} ${theme}`}
        onClick={() => setIsChatOpen(true)}
        title="Open AI Assistant"
      >
        <i className="bi bi-robot"></i>
        <div className="chatbot-btn-pulse"></div>
      </button>

      <AIChatbot
        isOpen={isChatOpen}
        onClose={() => setIsChatOpen(false)}
        apiBaseUrl={apiBaseUrl}
        theme={theme}
      />
    </>
  );
};

export default ChatbotButton;
